<div  class="events-lobby">
    <div class="events-lobby_header portal-lobby-container">
        <h1 class="events-lobby_header-title">
            {{ pageData?.title }}
            <app-skeleton *ngIf="!pageData" [type]="'text'" [symbolsCount]="10"/>
        </h1>
        <h2 *ngIf="!pageData || pageData.subTitle" class="events-lobby_header-subTitle pre-line">
            {{ pageData?.subTitle }}
            <app-skeleton *ngIf="!pageData" [type]="'text'" [symbolsCount]="100"/>
        </h2>
        <div class="lobby-filters" *ngIf="pageData" [ngClass]="{'hide-mobile': isMobile}">
            <div class="search-box">
                <mat-form-field appearance="outline" class="mb-0">
                  <input matInput [placeholder]="pageData.searchPlaceHolder" [value]="searchTerm" (input)="onInputChange($event)" [disabled]="isLoading">
                  <mat-icon matPrefix [svgIcon]="'search'" class="square-icon search-icon"></mat-icon>
                </mat-form-field>
            </div>

            <app-custom-datepicker [placeholder]="pageData.startDatePlaceHolder" [selectedDate]="searchRequest.fromDate" [disabled]="isLoading"
                (dateChange)="changeDateFrom($event)"></app-custom-datepicker>
            <app-custom-datepicker [placeholder]="pageData.endDatePlaceHolder" [selectedDate]="searchRequest.toDate" [disabled]="isLoading"
                (dateChange)="changeDateTo($event)"></app-custom-datepicker>

            <app-multi-select *ngIf="pageData.eventsLobbyData.interests && pageData.eventsLobbyData.interests.length" 
                [filterItems]="pageData.eventsLobbyData.interests" [selectedValue]="searchRequest.interest" [label]="pageData.interestsPlaceholder" [disabled]="isLoading"
                (changeValue)="filtersChange($event, 1)"></app-multi-select>
            <app-multi-select *ngIf="pageData.eventsLobbyData.eventsTypes && pageData.eventsLobbyData.eventsTypes.length" 
                [filterItems]="pageData.eventsLobbyData.eventsTypes" [selectedValue]="searchRequest.eventTypes" [label]="pageData.eventTypesPlaceholder" [disabled]="isLoading"
                (changeValue)="filtersChange($event, 2)"></app-multi-select>
            <app-multi-select *ngIf="pageData.eventsLobbyData.campuses && pageData.eventsLobbyData.campuses.length" 
                [filterItems]="pageData.eventsLobbyData.campuses" [selectedValue]="searchRequest.campuses" [label]="pageData.campusesPlaceholder" [disabled]="isLoading"
                (changeValue)="filtersChange($event, 3)"></app-multi-select>
        </div>

        <div class="lobby-filters" *ngIf="!pageData" [ngClass]="{'hide-mobile': isMobile}">
            <div class="search-box">
                <app-skeleton [height]="48"/>
            </div>

            <app-skeleton [height]="48" *ngFor="let _ of [].constructor(5)"/>
        </div>


        <div class="lobby-filters-checks" [ngClass]="{'hide-mobile': isMobile}">
            <mat-checkbox
                class="lobby-filters-checks_checkbox"
                [labelPosition]="'after'"
                [disabled]="isLoading || pageData.eventsLobbyData.freeEventDisabled"
                [(ngModel)]="searchRequest.isFree"
                (ngModelChange)="checkboxChange()">
                {{pageData ? pageData.isFreeLabel : ""}}
                <app-skeleton *ngIf="!pageData" [type]="'text'" [symbolsCount]="10"/>
            </mat-checkbox>
            <mat-checkbox
                class="lobby-filters-checks_checkbox"
                [labelPosition]="'after'"
                [disabled]="isLoading || pageData.eventsLobbyData.onlineEventDisabled"
                [(ngModel)]="searchRequest.isOnline"
                (ngModelChange)="checkboxChange()">
                {{pageData ? pageData.isOnlineLabel : ""}}
                <app-skeleton *ngIf="!pageData" [type]="'text'" [symbolsCount]="10"/>
            </mat-checkbox>
        </div>

        <div class="lobby-filters-mobile" [ngClass]="{'hide-mobile': !isMobile}">
            <div class="search-box">
                <mat-form-field *ngIf="pageData" appearance="outline" class="mb-0">
                  <input matInput [placeholder]="pageData.searchPlaceHolder" [value]="searchTerm" (input)="onInputChange($event)" [disabled]="isLoading">
                  <mat-icon matPrefix [svgIcon]="'search'" class="square-icon search-icon"></mat-icon>
                </mat-form-field>
                <app-skeleton *ngIf="!pageData" class="mb-0" [height]="48"/>
            </div>
            <div class="slide-up-header" *ngIf="pageData" (click)="openFiltersMobilePopup()">
                <div class="filter-icon">
                  <img src="/Content/Images/icons/filter.svg" alt="" width="36" height="36" />
                </div>
                <div class="filter-text">{{pageData.mobileFiltersLabel}}</div>
            </div>
            <div class="slide-up-header" *ngIf="!pageData">
                <div class="filter-icon">
                    <app-skeleton [width]="36" [height]="36" />
                </div>
                <div class="filter-text"><app-skeleton [type]="'text'" [symbolsCount]="20"/></div>
            </div>

            <div class="lobby-filters-mobile-popup" *ngIf="pageData && showFiltersMobileModal">
                <div class="lobby-filters-mobile-popup_content">
                    <span class="close" (click)="closeFiltersMobilePopup()">
                        &times;
                    </span>
                    <div class="slide-up-header">
                        <div class="filter-icon">
                          <img src="/Content/Images/icons/filter.svg" alt="" width="36" height="36" />
                        </div>
                        <div class="filter-text">{{pageData.mobileFiltersLabel}}</div>
                    </div>
                    <div class="slide-up-filters-content">
                        <app-expansion-date-panel
                            [title]="pageData.mobileDateRangeFilterLabel"
                            [startDatePlaceHolder]="pageData.startDatePlaceHolder"
                            [endDatePlaceHolder]="pageData.endDatePlaceHolder"
                            [fromDate]="searchRequest.fromDate"
                            [toDate]="searchRequest.toDate"
                            [disabled]="isLoading"
                            (fromDateChanged)="changeDateFrom($event)"
                            (toDateChanged)="changeDateTo($event)"
                        ></app-expansion-date-panel>
                        <app-expansion-mobile-multi-select-panel
                            *ngIf="pageData.eventsLobbyData.interests && pageData.eventsLobbyData.interests.length" 
                            [filterItems]="pageData.eventsLobbyData.interests" 
                            [label]="pageData.interestsPlaceholder" 
                            [disabled]="isLoading"
                            (changeValue)="filtersChangeMobile($event, 1)"
                        ></app-expansion-mobile-multi-select-panel>
                        <app-expansion-mobile-multi-select-panel
                            *ngIf="pageData.eventsLobbyData.eventsTypes && pageData.eventsLobbyData.eventsTypes.length" 
                            [filterItems]="pageData.eventsLobbyData.eventsTypes" 
                            [label]="pageData.eventTypesPlaceholder" 
                            [disabled]="isLoading"
                            (changeValue)="filtersChangeMobile($event, 2)"
                        ></app-expansion-mobile-multi-select-panel>
                        <app-expansion-mobile-multi-select-panel
                            *ngIf="pageData.eventsLobbyData.campuses && pageData.eventsLobbyData.campuses.length" 
                            [filterItems]="pageData.eventsLobbyData.campuses" 
                            [label]="pageData.campusesPlaceholder" 
                            [disabled]="isLoading"
                            (changeValue)="filtersChangeMobile($event, 3)"
                        ></app-expansion-mobile-multi-select-panel>
                        <div class="lobby-filters-checks">
                            <mat-checkbox
                                class="lobby-filters-checks_checkbox"
                                [labelPosition]="'after'"
                                [disabled]="pageData.eventsLobbyData.freeEventDisabled || isLoading"
                                [(ngModel)]="searchRequest.isFree"
                                (ngModelChange)="checkboxChange()">
                                {{pageData.isFreeLabel}}
                            </mat-checkbox>
                            <mat-checkbox
                                class="lobby-filters-checks_checkbox"
                                [labelPosition]="'after'"
                                [disabled]="pageData.eventsLobbyData.onlineEventDisabled || isLoading"
                                [(ngModel)]="searchRequest.isOnline"
                                (ngModelChange)="checkboxChange()">
                                {{pageData.isOnlineLabel}}
                            </mat-checkbox>
                        </div>
                    </div>
                    <div class="slide-up-filters-bottom">
                        <button class="slide-up-filters-bottom__clear-btn link" (click)="clearSearch($event)">
                            {{pageData.cleanSearchText}}
                        </button>
                        <button class="slide-up-filters-bottom__search-submit" (click)="closeFiltersMobilePopup()">
                            {{pageData.mobileDisplayResults}}
                        </button>
                      </div>
                </div>
            </div>
        </div>
    </div>

    <div class="events-lobby-list">
        <ng-container *ngIf="checkIfShowEventsList() && !isLoading">
            <app-event-lobby-item *ngFor="let event of pageData.eventsLobbyData.eventsList" 
                [event]="event"
                [freeEventText]="pageData.isFreeLabel"
                [onlineEventText]="pageData.isOnlineLabel"
                [atHourText]="pageData.atHourText"
                [addToDiaryBtnText]="pageData.previewButtonAddingEvent"
                [shareCalendarIcons]="pageData.shareCalendarIcons"
                [registrationEventText]="pageData.previewButtonRegistrationForEvent"
                [socialShareSettings]="pageData.socialShareSettings"
                [antiToken]="pageData.antiforgeryToken"
            />
        </ng-container>
        <ng-container *ngIf="isLoading">
            <app-event-lobby-item *ngFor="let _ of [].constructor(pageData ? pageData.eventsPerPage : 4)"
                [event]=""
                [freeEventText]="''"
                [onlineEventText]="''"
                [atHourText]="''"
                [addToDiaryBtnText]="''"
                [registrationEventText]="''"
                [isLoading]="true"
            />
        </ng-container>
    </div>

    <div *ngIf="checkIfShowEventsList() && !isLoading" class="events-lobby_footer">
        <app-paginator 
            [totalResults]="pageData.eventsLobbyData.totalResults" 
            [currentPage]="currentPage" 
            [pageSize]="pageData.eventsPerPage" 
            (pageChanged)="goToPage($event)"  
            [paginatorContainerClass]="paginatorContainerCssClass"  
            [activeLiClass]="'active'"
            [activeLinkClass]="'active'" 
            [liClass]="'pagination__link'" 
            [linkClass]="'pagination__link_a'" 
            [rangeSize]="rangeSize"
        ></app-paginator>
    </div>

    <div *ngIf="!checkIfShowEventsList() && !isLoading" class="events-lobby-list-empty">
        <div class="events-lobby-list-empty_title">{{pageData.noResultsTitle}}</div>
        <div *ngIf="pageData.noResultsText" class="events-lobby-list-empty_sub-title" [innerHTML]="pageData.noResultsText"></div>
        <a (click)="clearSearch($event)">{{pageData.cleanSearchText}}</a>
        <div *ngIf="pageData.noResultsImage" class="events-lobby-list-empty_img">
            <img [src]="pageData.noResultsImage" />
        </div>
    </div>
</div>